import React from 'react';

function Footer() {
  return (
    <div className="footer">
      <div className="container">
        <h1>Team</h1>
        <ul>
          <li>Huiwen Shi</li>
          <li>Rui Wang</li>
          <li>Ziyi Tang</li>
          <li>Yingu Pan</li>
        </ul>
        {/* <div className={classes.logo-container}>
        <img src="../../assets/mit-logo.png" alt="mit logo" />
      </div> */}
      </div>
    </div>
  );
}

export default Footer;
